export default function Eye(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				d="M9.99999 15.2382C14.4709 15.2382 18.0952 12.893 18.0952 10.0001C18.0952 7.10714 14.4709 4.76196 9.99999 4.76196C5.52912 4.76196 1.90475 7.10714 1.90475 10.0001C1.90475 12.893 5.52912 15.2382 9.99999 15.2382Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M10 12.381C11.315 12.381 12.381 11.3151 12.381 10.0001C12.381 8.68513 11.315 7.61914 10 7.61914C8.68504 7.61914 7.61905 8.68513 7.61905 10.0001C7.61905 11.3151 8.68504 12.381 10 12.381Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	);
}
